import React from 'react';
import Icon from './arrow.svg';

const ArrowIcon = ({height='100%', width='100%', color='white', strokeColor='white', className=''}) => {
	return <div className={className}>
		<svg
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			viewBox="0 0 24 27"
			width={width}
			height={height}
			aria-hidden={true}
			enableBackground="new 0 0 24 27"
			xmlSpace="preserve"
		>
			<g filter="url(#filter0_d_3350_2504)">
				<path fill={color} stroke={strokeColor} d="M10.0508 6.35211C8.69043 5.56614 7.1588 6.1405 6.65497 7.63183C6.65497 7.63183 6 9.53629 6 12.1058C6 14.6753 6.58444 16.3682 6.58444 16.3682C7.07819 17.8595 8.59974 18.4339 9.96007 17.6479L17.3059 13.4057C18.6662 12.6197 18.6662 11.3299 17.3059 10.5439L10.0508 6.35211Z"/>
			</g>
			<defs>
				<filter id="filter0_d_3350_2504" x="-4" y="0" width="32" height="32" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
					<feFlood floodOpacity="0" result="BackgroundImageFix"/>
					<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
					<feOffset dy="4"/>
					<feGaussianBlur stdDeviation="2"/>
					<feComposite in2="hardAlpha" operator="out"/>
					<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
					<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3350_2504"/>
					<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3350_2504" result="shape"/>
				</filter>
			</defs>
		</svg>
	</div>
};

export default ArrowIcon;
